import { colors } from '@styles/colors'
import { useStyletron } from 'baseui'
import { forwardRef } from 'react'
import { Textarea } from 'baseui/textarea'
import { useInputOverrides } from '../base-input/use-input-overrides'
import { LabelS } from '../base-typography'
import { useOverrides } from '../hooks/use-overrides'
import { Icon, IconType } from '../icon'
import { BaseTextareaProps } from './textarea.interface'
import { margin } from 'polished'

export const BaseTextarea = forwardRef<Textarea, BaseTextareaProps>(
  (
    {
      overrides,
      leading,
      trailing,
      action,
      onAction,
      error,
      positive,
      disabled,
      spaceTop,
      spaceBottom,
      label,
      size = 'l',
      ...props
    },
    ref
  ) => {
    const { inputOverrides } = useInputOverrides({
      spaceTop,
      spaceBottom,
      size,
      label,
    })

    return (
      <>
        <Textarea
          clearable
          overrides={useOverrides(
            useOverrides(inputOverrides, {
              Input: {
                style: {
                  maxHeight: '800px',
                  minHeight: '240px',
                  minWidth: 'calc(100% - 16px)',
                  width: '100%',
                  resize: 'vertical',
                  margin: '0px 0px 2px',
                },
              },
              InputContainer: {
                style: {
                  maxWidth: '100%',
                  minWidth: '100%',
                  width: 'min-content',
                },
              },
            }),
            overrides
          )}
          error={Boolean(error)}
          positive={Boolean(positive)}
          disabled={disabled}
          {...props}
          ref={ref}
        />
        {!disabled && error && <Hint msg={error} type="error" />}
        {!disabled && positive && <Hint msg={positive} type="positive" />}
      </>
    )
  }
)

interface HintProps {
  msg: string
  type: 'error' | 'positive'
}

export const Hint = ({ msg, type }: HintProps) => {
  const [css] = useStyletron()

  const style = {
    error: {
      color: colors.red400,
      icon: 'Spam2Line' as IconType,
    },
    positive: {
      color: colors.green400,
      icon: 'CheckDoubleFill' as IconType,
    },
  }[type]

  return (
    <span
      className={css({
        display: 'inline-flex',
        alignItems: 'center',
        marginTop: '4px',
      })}
    >
      <Icon type={style.icon} size={16} color={style.color} />
      <LabelS color={style.color} marginLeft="4px">
        {msg}
      </LabelS>
    </span>
  )
}
